var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3C7.489 3 3 7.489 3 13C3 18.511 7.489 23 13 23C15.3965 23 17.5974 22.149 19.3223 20.7363L25.293 26.707C25.3851 26.803 25.4955 26.8796 25.6176 26.9324C25.7397 26.9852 25.8712 27.0131 26.0042 27.0144C26.1373 27.0158 26.2692 26.9906 26.3924 26.9403C26.5156 26.89 26.6275 26.8156 26.7216 26.7216C26.8156 26.6275 26.89 26.5156 26.9403 26.3924C26.9906 26.2692 27.0158 26.1373 27.0144 26.0042C27.0131 25.8712 26.9852 25.7397 26.9324 25.6176C26.8796 25.4955 26.803 25.3851 26.707 25.293L20.7363 19.3223C22.149 17.5974 23 15.3965 23 13C23 7.489 18.511 3 13 3ZM13 5C17.4301 5 21 8.56988 21 13C21 17.4301 17.4301 21 13 21C8.56988 21 5 17.4301 5 13C5 8.56988 8.56988 5 13 5Z",
    fill: "#989DA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.dbe65f283ba4315bc958c972d3c25c3b.svg";
export { ForwardRef as ReactComponent };